<template>
  <section>
    <!-- search -->
    <form @submit.prevent="loadData">
      <div class="section_search">
        <div class="tray">
          <div class="row">
            <div class="cell">
              <select v-model="formData.type">
                <option value="PAGEVIEW">사용건수 보기</option>
                <option value="USERVIEW">사용자수 보기</option>
              </select>

              <MonthPicker class="blank" ref="picker"
              :value="$utils.calcDate(null, '-1y')"
              :maxDate="new Date()"
              />
              <span class="text">부터 1년</span>
            </div>
            <span class="label">지역</span>
            <div class="cell">
              <GroupSelector
              permissionCode="statistic"
              :useGroup="false"
              ref="groupSelector"
              />
              <button type="submit" class="btn_search">검색</button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- //search -->

    <StatTotal :statData="statData" excelName="전체통계(Monthly)" />
  </section>
</template>

<script>

  import StatTotal from './components/StatTotal'
  import mixin from './_mixin'

  export default {
    components: { StatTotal },
    mixins: [ mixin ],
    data() {
      return {
        apiUrl: '/admin/happy/stats/monthly',
        statData: null,
        formData: {
          type: 'PAGEVIEW',
          searchDate: '',
          state: '', city: ''
        }
      }
    },
    methods: {
      requestOptions() {
        const group = this.$refs.groupSelector.getData()
        const startDate = this.$refs.picker.getDate()
        return { params: _.merge(this.formData, {
          searchDate: this.$utils.dateformat(startDate, 'yyyy-mm-dd'),
          orgCode: group.orgId,
          state: group.stateId,
          city: group.cityId,
        })}
      },
      loadData() {
        this.$axios.get('/admin/happy/stats/monthly', this.requestOptions()).then(({data}) => this.statData = data.data)
      }
    },
    mounted() {
      this.loadData()
    }
  }

</script>
